import { Chart, Plugin } from 'chart.js';

export const increaseLegendSpacingPlugin: Plugin<'line'> = {
	id: 'increase-legend-spacing',
	/* eslint-disable */
	beforeInit(chart: any) {
		const originalFit = chart.legend.fit;
		chart.legend.fit = function fit() {
			originalFit.bind(chart.legend)();
			this.height += 16;
		};
	},
	/* eslint-enable */
};

export const increaseLegendOffsetPlugin: Plugin<'line'> = {
	id: 'increase-legend-offset',
	afterUpdate(chart: Chart<'line'>) {
		const { legend } = chart;
		if (!legend) return;
		legend.left += 20;
	},
};

export const chartBackgroundPlugin = {
	id: 'chartBackgroundPlugin',
	beforeDraw: (chart: Chart<'line'>) => {
		const { ctx, width, height } = chart;
		ctx.save();
		ctx.fillStyle = '#F4F4F4';
		ctx.fillRect(0, 0, width, height);
		ctx.restore();
	},
};
